// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Main Container */
.main-container {
  background-color: #dedede;
  margin: 0; 
  padding: 0; 
  height: 100%;
}

.home-search-section {
  background-color: #dedede;
  background-image: none;
  border-bottom: 0;
  padding: 44px 28px 30px;
}

/* Heading */
.heading {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-weight: 700;
  font-size: 4.4rem;
  font-style: normal;
  line-height: 100%;
  margin-top: 0;
}

.sub-heading-1 {
  color: rgb(18, 57, 77);
  font-family: "Roboto Bold", "Roboto", sans-serif;
}

.sub-heading-2 {
  font-family: "Roboto Bold", "Roboto", sans-serif;
  color: rgb(66, 126, 147);
  font-weight: 200;
}

/* Sub Heading - Explore */
.sub-heading-font {
  color: #333;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  /* font-size: 50%; */
}

/* Sub Heading - Arab American History */
.sub-heading-font2 {
  font-family: "Roboto Bold", "Roboto", sans-serif;
  color: #427e93;
  font-weight: 200;
}

/* Search Div */
.search-div {
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 60px;
}

/* Search Input */
.search-input {
  text-indent: 10%;
  font-size: 22px;
  height: 68px;
  width: 720px;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  border-bottom: 2px solid #cccccc;
  border-radius: 36px;
  font-family: "Roboto Bold", "Roboto", sans-serif;
}

/* Or Image Div */
.or-image-div {
  height: 58px;
  width: 22px;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  /* font-size: 16px; */
  /* line-height: 150%; */
  text-align: center;
  color: #fff;
  margin-top: 22px;
}

.or-image-div svg{
  height: 58px;
  width: min(820px, 76vw);
}

@media (max-width: 550px){
  .or-image-div svg{
    height: 48px;
    width: 90%;
  }
}


/* Browse Collection Div */
.browse-collection-div {
  display: flex;
  justify-content: center;
  text-align: center;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  line-height: 1.15;
  margin-top: 25px;
  margin-bottom: 14px;
}

/* Browse Text - Browse our collection */
.browse-text-span {
  color: #666666;
  display: inline-block;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 28px;
  letter-spacing: 0;
  text-transform: none;
}

/* Browse Text - By Selecting */
.by-selecting-span {
  color: #999;
  display: inline-block;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 24px;
  margin-top: 5px;
}

/* Collections Div */
.collections-div {
  text-align: center;
  border-right: 2px solid #cccccc;
}

/* Icon Style */
.icon-style {
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: end;
}

/* Info Style */
.info-style {
  padding: 8px;
  margin: 0px;
  display: flex;
  align-items: center;
}

/* Span Style - 4382 */
.span-style-4382 {
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 40px;
  color: #427e93;
}

/* Span Style - Below 4382 */
.span-style-below-4382 {
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  color: #808080;
}

/* Search and Browse Div */
.search-browse-div {
  display: flex;
  justify-content: center;
  text-align: center;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 2rem;
  line-height: 1.5;
  color: #666666;
  margin-left: auto;
  margin-right: auto;
  max-width: 1120px;
  padding: 0;
}

@media (max-width: 600px){
  .search-browse-div{
    font-size: 1.5rem;
  }
}

/* Learn More Span */
.learn-more-span {
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 167%;
  color: #ff0000;
}

/* Drop Down Style */
.drop-down-style {
  height: 48px;
  border: 1px solid #cccccc;
  border-radius: 36px;
  background-color: #ffffff;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #808080;
  padding-left: 10px;
}


.stats-panel {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 18px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(18, 57, 77, 0.08);
  margin: 26px auto 46px;
  max-width: 1320px;
  overflow: hidden;
  width: calc(100% - 56px);
}

.stats {
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #d9d9d9;
  margin: 0;
  min-height: 112px;
  padding: 22px 34px;
}

.stats:first-child {
  border-left: 0;
}

.stats .icon-style {
  justify-content: center;
  padding: 0 22px 0 0;
}

.stats .icon-style img {
  filter: invert(39%) sepia(19%) saturate(1137%) hue-rotate(144deg) brightness(89%) contrast(87%);
  height: 34px !important;
  width: 34px !important;
}

.stats .info-style {
  padding: 0;
}

.stats .info-style p {
  margin: 0;
}

.stats .span-style-4382 {
  color: #1f1f1f;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
}

.stats .span-style-below-4382 {
  color: #666666;
  display: block;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.2;
  margin-top: 5px;
  text-transform: uppercase;
}

.periodicals-books {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  gap: 32px;
  margin: 26px auto 34px;
  max-width: 1320px;
  padding: 0;
  width: calc(100% - 56px);
}

.browse-format-card {
  align-items: flex-start;
  background: #ffffff;
  border: 3px solid #3f7986;
  border-radius: 24px;
  color: #1f1f1f;
  cursor: pointer;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  min-height: 205px;
  padding: 26px;
  text-align: left;
  transition: background-color 180ms ease, border-color 180ms ease,
    box-shadow 180ms ease, color 180ms ease, transform 180ms ease;
}

.browse-format-card:hover,
.browse-format-card:focus-visible,
.browse-format-card.is-selected,
.browse-format-card:active {
  background: #3f7986;
  border-color: #3f7986;
  box-shadow: 0 20px 40px rgba(18, 57, 77, 0.16);
  color: #ffffff;
  transform: translateY(-4px);
}

.browse-format-card:focus-visible {
  outline: 4px solid rgba(66, 126, 147, 0.35);
  outline-offset: 5px;
}

.browse-format-card__icon {
  align-items: center;
  background: #edf3f4;
  border-radius: 14px;
  color: #3f7986;
  display: inline-flex;
  font-size: 22px;
  height: 54px;
  justify-content: center;
  margin-bottom: 24px;
  width: 54px;
}

.browse-format-card:hover .browse-format-card__icon,
.browse-format-card:focus-visible .browse-format-card__icon,
.browse-format-card.is-selected .browse-format-card__icon,
.browse-format-card:active .browse-format-card__icon {
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
}

.browse-format-card__title {
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 27px;
  font-weight: 700;
  line-height: 1.15;
  margin-bottom: 8px;
}

.browse-format-card__subtitle {
  color: #666666;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.25;
  margin-bottom: 24px;
}

.browse-format-card:hover .browse-format-card__subtitle,
.browse-format-card:focus-visible .browse-format-card__subtitle,
.browse-format-card.is-selected .browse-format-card__subtitle,
.browse-format-card:active .browse-format-card__subtitle {
  color: rgba(255, 255, 255, 0.75);
}

.browse-format-card__cta {
  align-items: center;
  background: #edf3f4;
  border-radius: 16px;
  color: #3f7986;
  display: inline-flex;
  font-size: 17px;
  font-weight: 800;
  gap: 12px;
  margin-top: auto;
  min-height: 48px;
  padding: 0 18px;
}

.browse-format-card:hover .browse-format-card__cta,
.browse-format-card:focus-visible .browse-format-card__cta,
.browse-format-card.is-selected .browse-format-card__cta,
.browse-format-card:active .browse-format-card__cta {
  background: rgba(255, 255, 255, 0.26);
  color: #ffffff;
}

.home-pattern-strip {
  background: #ffffff;
  display: flex;
  justify-content: center;
  margin: 72px auto 0;
  overflow: hidden;
  width: 100%;
}

.home-pattern-strip img {
  display: block;
  max-width: none;
  width: 100%;
}

.home-intro-section {
  background: #ffffff;
  padding: 28px 24px 98px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.learn-more-link {
  cursor: pointer;
  text-align: center;
  text-decoration: none;
}

@media (max-width: 700px) {
  .heading{
    font-size: 3.6rem;
  }
}

@media (max-width: 380px) {
  .heading{
    font-size: 2.9rem;
  }
}

@media (max-width: 600px){
  .periodicals-books{
    flex-direction: column;
    gap: 18px;
    margin-top: 24px;
    padding: 0 18px;
    width: 100%;
  }

  .browse-format-card {
    min-height: 0;
    padding: 22px;
  }

  .browse-format-card__icon {
    height: 48px;
    margin-bottom: 18px;
    width: 48px;
  }

  .browse-format-card__title {
    font-size: 24px;
  }

  .browse-format-card__subtitle {
    font-size: 17px;
    margin-bottom: 20px;
  }

  .browse-format-card__cta {
    font-size: 16px;
    min-height: 46px;
    width: 100%;
    justify-content: center;
  }

  .stats-panel {
    width: calc(100% - 24px);
  }

  .stats {
    border-left: 0;
    border-top: 1px solid #d9d9d9;
    justify-content: flex-start;
    min-height: 96px;
  }

  .stats:first-child {
    border-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/home.css"],"names":[],"mappings":";AACA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;EAChD,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA,wCAAwC;AACxC;EACE,gDAAgD;EAChD,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,WAAW;EACX,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE;IACE,YAAY;IACZ,UAAU;EACZ;AACF;;;AAGA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,cAAc;EACd,qBAAqB;EACrB,gDAAgD;EAChD,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,qBAAqB;EACrB,gDAAgD;EAChD,eAAe;EACf,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,oBAAoB;AACpB;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+FAA+F;EAC/F,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,SAAW;EACX,sBAAsB;EACtB,gDAAgD;EAChD,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB;iEAC+D;AACjE;;AAEA;;;;EAIE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;EAC9C,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;EAIE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;EAIE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,6BAA6B;IAC7B,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["\n/* Main Container */\n.main-container {\n  background-color: #dedede;\n  margin: 0; \n  padding: 0; \n  height: 100%;\n}\n\n.home-search-section {\n  background-color: #dedede;\n  background-image: none;\n  border-bottom: 0;\n  padding: 44px 28px 30px;\n}\n\n/* Heading */\n.heading {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-size: 4.4rem;\n  font-style: normal;\n  line-height: 100%;\n  margin-top: 0;\n}\n\n.sub-heading-1 {\n  color: rgb(18, 57, 77);\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n}\n\n.sub-heading-2 {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  color: rgb(66, 126, 147);\n  font-weight: 200;\n}\n\n/* Sub Heading - Explore */\n.sub-heading-font {\n  color: #333;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  /* font-size: 50%; */\n}\n\n/* Sub Heading - Arab American History */\n.sub-heading-font2 {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  color: #427e93;\n  font-weight: 200;\n}\n\n/* Search Div */\n.search-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  margin-top: 60px;\n}\n\n/* Search Input */\n.search-input {\n  text-indent: 10%;\n  font-size: 22px;\n  height: 68px;\n  width: 720px;\n  border-top: 0px;\n  border-left: 0px;\n  border-right: 0px;\n  border-bottom: 2px solid #cccccc;\n  border-radius: 36px;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n}\n\n/* Or Image Div */\n.or-image-div {\n  height: 58px;\n  width: 22px;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  /* font-size: 16px; */\n  /* line-height: 150%; */\n  text-align: center;\n  color: #fff;\n  margin-top: 22px;\n}\n\n.or-image-div svg{\n  height: 58px;\n  width: min(820px, 76vw);\n}\n\n@media (max-width: 550px){\n  .or-image-div svg{\n    height: 48px;\n    width: 90%;\n  }\n}\n\n\n/* Browse Collection Div */\n.browse-collection-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.15;\n  margin-top: 25px;\n  margin-bottom: 14px;\n}\n\n/* Browse Text - Browse our collection */\n.browse-text-span {\n  color: #666666;\n  display: inline-block;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 28px;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n/* Browse Text - By Selecting */\n.by-selecting-span {\n  color: #999;\n  display: inline-block;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 24px;\n  margin-top: 5px;\n}\n\n/* Collections Div */\n.collections-div {\n  text-align: center;\n  border-right: 2px solid #cccccc;\n}\n\n/* Icon Style */\n.icon-style {\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n/* Info Style */\n.info-style {\n  padding: 8px;\n  margin: 0px;\n  display: flex;\n  align-items: center;\n}\n\n/* Span Style - 4382 */\n.span-style-4382 {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 40px;\n  color: #427e93;\n}\n\n/* Span Style - Below 4382 */\n.span-style-below-4382 {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 150%;\n  color: #808080;\n}\n\n/* Search and Browse Div */\n.search-browse-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 2rem;\n  line-height: 1.5;\n  color: #666666;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1120px;\n  padding: 0;\n}\n\n@media (max-width: 600px){\n  .search-browse-div{\n    font-size: 1.5rem;\n  }\n}\n\n/* Learn More Span */\n.learn-more-span {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 167%;\n  color: #ff0000;\n}\n\n/* Drop Down Style */\n.drop-down-style {\n  height: 48px;\n  border: 1px solid #cccccc;\n  border-radius: 36px;\n  background-color: #ffffff;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n  color: #808080;\n  padding-left: 10px;\n}\n\n\n.stats-panel {\n  background: #ffffff;\n  border: 1px solid #d9d9d9;\n  border-radius: 18px;\n  box-sizing: border-box;\n  box-shadow: 0 1px 3px rgba(18, 57, 77, 0.08);\n  margin: 26px auto 46px;\n  max-width: 1320px;\n  overflow: hidden;\n  width: calc(100% - 56px);\n}\n\n.stats {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-left: 1px solid #d9d9d9;\n  margin: 0;\n  min-height: 112px;\n  padding: 22px 34px;\n}\n\n.stats:first-child {\n  border-left: 0;\n}\n\n.stats .icon-style {\n  justify-content: center;\n  padding: 0 22px 0 0;\n}\n\n.stats .icon-style img {\n  filter: invert(39%) sepia(19%) saturate(1137%) hue-rotate(144deg) brightness(89%) contrast(87%);\n  height: 34px !important;\n  width: 34px !important;\n}\n\n.stats .info-style {\n  padding: 0;\n}\n\n.stats .info-style p {\n  margin: 0;\n}\n\n.stats .span-style-4382 {\n  color: #1f1f1f;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.stats .span-style-below-4382 {\n  color: #666666;\n  display: block;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 15px;\n  font-weight: 800;\n  letter-spacing: 0;\n  line-height: 1.2;\n  margin-top: 5px;\n  text-transform: uppercase;\n}\n\n.periodicals-books {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  gap: 32px;\n  margin: 26px auto 34px;\n  max-width: 1320px;\n  padding: 0;\n  width: calc(100% - 56px);\n}\n\n.browse-format-card {\n  align-items: flex-start;\n  background: #ffffff;\n  border: 3px solid #3f7986;\n  border-radius: 24px;\n  color: #1f1f1f;\n  cursor: pointer;\n  display: flex;\n  flex: 1 1 0;\n  flex-direction: column;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  min-height: 205px;\n  padding: 26px;\n  text-align: left;\n  transition: background-color 180ms ease, border-color 180ms ease,\n    box-shadow 180ms ease, color 180ms ease, transform 180ms ease;\n}\n\n.browse-format-card:hover,\n.browse-format-card:focus-visible,\n.browse-format-card.is-selected,\n.browse-format-card:active {\n  background: #3f7986;\n  border-color: #3f7986;\n  box-shadow: 0 20px 40px rgba(18, 57, 77, 0.16);\n  color: #ffffff;\n  transform: translateY(-4px);\n}\n\n.browse-format-card:focus-visible {\n  outline: 4px solid rgba(66, 126, 147, 0.35);\n  outline-offset: 5px;\n}\n\n.browse-format-card__icon {\n  align-items: center;\n  background: #edf3f4;\n  border-radius: 14px;\n  color: #3f7986;\n  display: inline-flex;\n  font-size: 22px;\n  height: 54px;\n  justify-content: center;\n  margin-bottom: 24px;\n  width: 54px;\n}\n\n.browse-format-card:hover .browse-format-card__icon,\n.browse-format-card:focus-visible .browse-format-card__icon,\n.browse-format-card.is-selected .browse-format-card__icon,\n.browse-format-card:active .browse-format-card__icon {\n  background: rgba(255, 255, 255, 0.18);\n  color: #ffffff;\n}\n\n.browse-format-card__title {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 27px;\n  font-weight: 700;\n  line-height: 1.15;\n  margin-bottom: 8px;\n}\n\n.browse-format-card__subtitle {\n  color: #666666;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.25;\n  margin-bottom: 24px;\n}\n\n.browse-format-card:hover .browse-format-card__subtitle,\n.browse-format-card:focus-visible .browse-format-card__subtitle,\n.browse-format-card.is-selected .browse-format-card__subtitle,\n.browse-format-card:active .browse-format-card__subtitle {\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.browse-format-card__cta {\n  align-items: center;\n  background: #edf3f4;\n  border-radius: 16px;\n  color: #3f7986;\n  display: inline-flex;\n  font-size: 17px;\n  font-weight: 800;\n  gap: 12px;\n  margin-top: auto;\n  min-height: 48px;\n  padding: 0 18px;\n}\n\n.browse-format-card:hover .browse-format-card__cta,\n.browse-format-card:focus-visible .browse-format-card__cta,\n.browse-format-card.is-selected .browse-format-card__cta,\n.browse-format-card:active .browse-format-card__cta {\n  background: rgba(255, 255, 255, 0.26);\n  color: #ffffff;\n}\n\n.home-pattern-strip {\n  background: #ffffff;\n  display: flex;\n  justify-content: center;\n  margin: 72px auto 0;\n  overflow: hidden;\n  width: 100%;\n}\n\n.home-pattern-strip img {\n  display: block;\n  max-width: none;\n  width: 100%;\n}\n\n.home-intro-section {\n  background: #ffffff;\n  padding: 28px 24px 98px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.learn-more-link {\n  cursor: pointer;\n  text-align: center;\n  text-decoration: none;\n}\n\n@media (max-width: 700px) {\n  .heading{\n    font-size: 3.6rem;\n  }\n}\n\n@media (max-width: 380px) {\n  .heading{\n    font-size: 2.9rem;\n  }\n}\n\n@media (max-width: 600px){\n  .periodicals-books{\n    flex-direction: column;\n    gap: 18px;\n    margin-top: 24px;\n    padding: 0 18px;\n    width: 100%;\n  }\n\n  .browse-format-card {\n    min-height: 0;\n    padding: 22px;\n  }\n\n  .browse-format-card__icon {\n    height: 48px;\n    margin-bottom: 18px;\n    width: 48px;\n  }\n\n  .browse-format-card__title {\n    font-size: 24px;\n  }\n\n  .browse-format-card__subtitle {\n    font-size: 17px;\n    margin-bottom: 20px;\n  }\n\n  .browse-format-card__cta {\n    font-size: 16px;\n    min-height: 46px;\n    width: 100%;\n    justify-content: center;\n  }\n\n  .stats-panel {\n    width: calc(100% - 24px);\n  }\n\n  .stats {\n    border-left: 0;\n    border-top: 1px solid #d9d9d9;\n    justify-content: flex-start;\n    min-height: 96px;\n  }\n\n  .stats:first-child {\n    border-top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
